const ItemAvailabilities = () => import(/* webpackChunkName: "itemAvailabilities" */ '@/components/menueditor/itemAvailabilities')


export default {
    name: 'itemavailabilty',
    path: 'menueditor/itemavailabilty',
    redirect: '/menueditor/itemavailabilty/index',
    meta: {label: 'itemavailabilty'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'Index', auth: [0, 1, 2, 3, 4, 5, 6, 7]},
            component: ItemAvailabilities,
            props: true
        }
    ]
}
